import { MapTrackingGpsPoints, TransportMode, WaybillMapStop } from '../../common';

export class WaybillTrackingMap {
  transportMode: TransportMode;
  mapData: MapTrackingGpsPoints<WaybillMapStop>;
}
